module.exports = __webpack_public_path__ + "static/media/arrow.8dff95be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/arrow.svg
// module id = 114
// module chunks = 0